import React, { createContext, useReducer } from "react";
import DeviceInfoReducer, { initialState } from "@reducers/DeviceInfoReducer";

export const DeviceInfoContext = createContext(undefined);

const DeviceInfoProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DeviceInfoReducer, initialState);
  return (
    <DeviceInfoContext.Provider value={[state, dispatch]}>
      {children}
    </DeviceInfoContext.Provider>
  );
};

export default DeviceInfoProvider;
